/** One of the things global search can find. */
export enum SearchResultCategory {
  LOCATION = "Locations",
  DETAILS_V3 = "Details",
  POLICY = "Policies",
  REPORT = "Reports"
}

/** A pill selection — "all" plus every real category. */
export type SearchCategoryFilter = "all" | SearchResultCategory;

interface SearchEntryBase {
  id: string;
  title: string;
  /** Lowercased, checked against the query. */
  matchText: string;
  /** Extra prose to show/search when the title alone doesn't match. */
  snippet?: string;
  /** Omit when the group header already says everything (nothing more specific). */
  breadcrumb?: string;
  swivlStaffOnly?: boolean;
}

// Present only for value matches — where the match was found, not
// wherever the user currently happens to be viewing.
export interface SearchEntryScope {
  groupId?: number;
  locationId?: number;
}

export interface DetailsV3SearchEntry extends SearchEntryBase {
  category: SearchResultCategory.DETAILS_V3;
  subpage: string;
  scope?: SearchEntryScope;
}

export interface PolicySearchEntry extends SearchEntryBase {
  category: SearchResultCategory.POLICY;
  policyKey: string;
  scope?: SearchEntryScope;
}

export interface LocationSearchEntry extends SearchEntryBase {
  category: SearchResultCategory.LOCATION;
  locationId: number;
  groupId: number;
}

export interface ReportSearchEntry extends SearchEntryBase {
  category: SearchResultCategory.REPORT;
  dashboardId: string;
  folder: string;
  scope?: SearchEntryScope;
}

export type SearchEntry = DetailsV3SearchEntry | PolicySearchEntry | LocationSearchEntry | ReportSearchEntry;

export interface SearchMatch {
  entry: SearchEntry;
  /** True when the query matched the title itself, not just the snippet. */
  titleMatch: boolean;
}
